import { Constants } from '@salesforce/scv-connector-base';

interface RemovalDetails {
    isRemoved: boolean;
    preserveOtherCalls: boolean;
};

export interface ActiveParty {
    partyId: string;
    phoneNumber: string;
    interactionId: string;
    scenarioId: string;
    name: string;
    participantType: Constants.PARTICIPANT_TYPE;
    removalDetails: RemovalDetails;
    degCallAttributes: string;
}

function isRemovalDetails(data: unknown): data is RemovalDetails {
  if (typeof data === 'object' && data != null) {
    return (
      ('isRemoved' in data && typeof data.isRemoved === 'boolean') &&
            ('preserveOtherCalls' in data && typeof data.preserveOtherCalls === 'boolean')
    );
  }

  return false;
}

export function isActiveParty(data: unknown): data is ActiveParty {
  if (typeof data === 'object' && data != null) {
    const ret = (
      ('partyId' in data && typeof data.partyId === 'string') &&
            ('phoneNumber' in data && typeof data.phoneNumber === 'string') &&
            ('interactionId' in data && typeof data.interactionId === 'string') &&
            ('scenarioId' in data && typeof data.scenarioId === 'string') &&
            ('name' in data && typeof data.name === 'string') &&
            ('participantType' in data && typeof data.participantType === 'string') &&
            ('removalDetails' in data && isRemovalDetails(data.removalDetails)) &&
            ('degCallAttributes' in data && typeof data.degCallAttributes === 'string')
    );

    return ret;
  }

  return false;
}
